import { AuthUserProps, stateStatusType } from './actionType';

export interface AuthStateProps {
    authUser: AuthUserProps | null;
    isLoading: boolean;
    error: string | null;
    status: stateStatusType | null;
}

export interface LoginStateProps {
    authState: AuthStateProps;
    children?: React.ReactNode;
}

export const initialAuthSate: AuthStateProps = {
    authUser: null,
    isLoading: false,
    error: null,
    status: null
};

export const initialState: LoginStateProps = {
    authState: initialAuthSate
};
